// extracted by mini-css-extract-plugin
export default {"categories":"ProductList_categories__qnNRQ","categories__item":"ProductList_categories__item__TXJi3","active":"ProductList_active__67RGb"};